import { render } from "./TicketTimeEdit.vue?vue&type=template&id=27107cf4&scoped=true&ts=true"
import script from "./TicketTimeEdit.vue?vue&type=script&lang=ts"
export * from "./TicketTimeEdit.vue?vue&type=script&lang=ts"

import "./TicketTimeEdit.vue?vue&type=style&index=0&id=27107cf4&scoped=true&lang=less"
import "./TicketTimeEdit.vue?vue&type=style&index=1&id=27107cf4&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27107cf4"]])

export default __exports__